import React, { useEffect, useState } from "react";
import Claim from "./components/Claim";
import Code from "./components/Code";
import Error from "./components/Error";
import HelpMessage from "./components/HelpMessage";
import Card from "./components/Card";
import BluestacksLogo from "../components/BluestacksLogo";
import GiftCardImage from "./components/GiftCardImage";
import googlePlayGiftCard from "./../assets/GooglePlayGiftCard.png";
import axios from "axios";
import { getHost } from "./../utils";

function GiftCard() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [code, setCode] = useState("");
  const [authToken, setAuthToken] = useState(null);
  const [amount, setAmount] = useState(null);
  const [buttonText, setButtonText] = useState(null);
  const [cardUrl, setCardUrl] = useState(googlePlayGiftCard);
  const [email, setEmail] = useState(null);
  const [showOfferPopup, setShowOfferPopup] = useState(false);

  useEffect(() => {
    const url = new URLSearchParams(document.location.search);
    setAuthToken(url.get("auth_token"));
    setAmount(url.get("amount"));
    setCardUrl(url.get("card_type_image_url") ?? googlePlayGiftCard);
    setEmail(url.get("email"));
    setButtonText(url.get("claim_button_text"));
    setShowOfferPopup(url.get("show_bonus_offer"));
  }, []);

  useEffect(() => {
    if (!email || !authToken) return;
    const host = getHost();
    axios.post(`${host}/api/support_survey/stats`, {
      email: email,
      auth_token: authToken,
      event: "claim_page_impression",
    });
  }, [email, authToken]);

  const enrollSurveyClick = () => {
      const host = getHost();
      console.log("Enroll survey senging stat");
      axios.post(`${host}/api/support_survey/stats`, {
          email: email,
          auth_token: authToken,
          event: "enroll_button_click",
      });
  };

  const claimCard = (auth, email) => {
    const host = getHost();
    const url = `${host}/api/claim_card`;
    const body = {
      auth_token: auth,
      email: email,
    };

    const startTime = new Date().getTime();

    axios
      .post(url, body)
      .then((res) => {
        const endTime = new Date().getTime();
        console.log(`${endTime - startTime} milliseconds`);
        if (res.status === 200) {
          setError(false);
          setCode(res?.data?.code);
        } else if (res.status === 404) {
          setError(true);
        }
        console.log(res);
      })
      .catch((err) => {
        const endTime = new Date().getTime();
        console.log(`${endTime - startTime} milliseconds`);
        console.error(err);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleButtonClick = () => {
    setLoading(true);
    claimCard(authToken, email);
  };

  const showClaim = code === "";

  return (
    <div className="flex min-h-screen items-baseline justify-center bg-background p-2 md:items-center">
      <Card>
        <div className="flex w-full flex-col justify-between md:flex-row">
          <div className="flex flex-col items-center justify-start md:w-3/5 md:items-start">
            <BluestacksLogo className="mx-auto mb-2 md:mx-0" />
            {error ? (
              <Error />
            ) : showClaim ? (
              <Claim
                loading={loading}
                onButtonClick={handleButtonClick}
                amount={amount}
                buttonText={buttonText}
              />
            ) : (
              <Code
                code={code}
                amount={amount}
                showOfferPopup={showOfferPopup}
                enrollSurveyClick={enrollSurveyClick}
              />
            )}
            <HelpMessage />
          </div>
          <GiftCardImage src={cardUrl} />
        </div>
      </Card>
    </div>
  );
}

export default GiftCard;
